export default __webpack_public_path__ + "static/media/Sorcerer's Girdle of the Mandate.9f47d47b.jpg";